







import { Component, Prop, Vue } from "vue-property-decorator";
import CzIcon from "./CzIcon.vue";

@Component({ components: { CzIcon } })
export default class CzNotice extends Vue {
  @Prop({ type: String, default: "accent" }) tone!: "accent" | "alert" | "error" | "neutral";
}
